import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { GenerationEvent } from "onboarding/llm-analytics/_snippets/generation-event.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OnboardingContentWrapper mdxType="OnboardingContentWrapper">
    <GenerationEvent mdxType="GenerationEvent" />
    </OnboardingContentWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      